module.exports = __webpack_public_path__ + "static/image/font/pc/bmjua-5@3x.jpg?d7e64835";